import ShadowBox from "components/common/ShadowBox/ShadowBox";
import { useContext, useEffect, useState } from "react";
import AddFormForeign from "./AddFormEmerging";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Flex,
  Tooltip,
  Button,
  Text,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import { AiFillEye } from "react-icons/ai";
import { RiDeleteBin5Line } from "react-icons/ri";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import { HiOutlineRefresh } from "react-icons/hi";
import { Paginationlimit } from "components/common/functions/variable";
import _ from "lodash";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import TableLoader from "components/common/TableLoader/TableLoader";
import DeleteModal from "../component/DeleteModal/DeleteModal";
import Pagination from "components/common/Pagination/Pagination";
import EditFormForeign from "./EditFormEmerging";
import ViewForm from "../component/forms/ViewForm";
import SetDefaultModal from "../component/SetDefaultModal/SetDefaultModal";
import LogoViewer from "../component/LogoViewer/LogoViewer";
import PreviewModal from "../component/PreviewModal/PreviewModal";
import ForeignRegionDrawer from "./EmergingRegionDrawer";
import { FaEdit, FaClone } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { replaceLabelValueObjects } from "utils/functions/function";
import AddFormEmerging from "./AddFormEmerging";

type WorkFlow = {
  _id?: string;
  username: string;
  name: string;
  defaultActive: boolean;
  values: any;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
};

function WorkFlowTableEmerging() {
  const { toastNotify, workFlowData, accountDetails, workflowProcess, getUsersWorkFlows } = useContext(AppContext);
  const [data, setData] = useState<WorkFlow[]>([]);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [search, setSearch] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isCopied, setIsCopied] = useState<any>(null);
  const [openEditModel, setOpenEditModel] = useState<any>({
    open: false,
    data: null,
  });

  const [openDeleteModel, setOpenDeleteModel] = useState<any>({
    open: false,
    data: null,
  });

  const [isPreviewOpen, setIsPreviewOpen] = useState<any>({
    open: false,
    data: "",
  });
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [isForeignDrawerOpen, setIsForeignDrawerOpen] = useState(false);

  const [openDefaultModal, setOpenDefaultModal] = useState<any>({
    open: false,
    data: null,
  });
  const [logo, setLogo] = useState<any>({
    open: false,
    data: "",
  });

  // for logo viewer
  const handleOpenModal = (value: any) => {
    setLogo({
      open: true,
      data: { value },
    });
  };
  const handleCloseModal = () => {
    setLogo({
      open: false,
      data: "",
    });
  };

  // for Preview Modal
  const handleOpenPreviewModal = (value: any) => {
    setIsPreviewOpen({
      open: true,
      data: { value },
    });
  };
  const handleClosePreviewModal = () => {
    setIsPreviewOpen({
      open: false,
      data: "",
    });
  };

  const [cloneLoading, setCloneLoading] = useState<string | null>(null);

  const handleClone = async (workflow: any) => {
    try {
      setCloneLoading(workflow._id);
      const newIdentifier = uuidv4();
      const newWorkFlowName = `${workflow.workFlowName} - Clone`;

      const clonePayload = {
        ...workflow.values,
        workFlowName: newWorkFlowName,
        identifier: newIdentifier,
        processName: workflow.processName,
        processType: workflow.processType,
      };

      const response: any = await appRequest("workflow", "create", replaceLabelValueObjects(clonePayload));

      if (response.status === "success" || response.status === 200) {
        toastNotify({
          title: "Foreign Workflow Cloned successfully",
          message: response.message || "The workflow has been duplicated.",
          type: "success",
        });
        handleGetWorkFlow();
        getUsersWorkFlows();
      } else {
        toastNotify({
          title: "Error cloning workflow",
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (err: any) {
      console.error("Clone error:", err);
      toastNotify({
        title: "Error cloning workflow",
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setCloneLoading(null);
    }
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  const handleCopyClick = (value: string) => {
    const idToCopy = value;
    if (idToCopy) {
      navigator.clipboard.writeText(idToCopy);
      setIsCopied(idToCopy);
      setTimeout(() => {
        setIsCopied(null);
      }, 2000);
    }
  };

  const handleGetWorkFlow = async (currentP?: number, valu?: any) => {
    try {
      setLoading(true);
      let value = valu ? valu : search;
      let limit = Paginationlimit;
      let sort = 1;
      let page = currentP ? currentP : currentPage;
      let object: any = {
        value,
        limit,
        sort,
        page,
        ...workflowProcess,
        searchField: "workFlowName"
      };

      const response: any = await appRequest("workflow", "get", object);
      if (response) {
        if (Array.isArray(response?.data)) {
          setData(response?.data);
          setTotalPages(response?.totalPages);
        } else {
          toastNotify({
            title: `Error getting the workflows`,
            message: response?.message || "Something went wrong.",
            type: "error",
          });
        }
      } else {
        toastNotify({
          title: `Error getting the workflows.`,
          message: "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the workflows.`,
        message: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialLoad) {
      handleGetWorkFlow(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = _.debounce((search) => {
        handleGetWorkFlow(currentPage, search);
      }, 1000);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [search, currentPage]);

  const handleDownloadExcel = async () => {
    setIsDownloading(true);
    try {
      const response: any = await appRequest("workflow", "generateUserApprovalsExcel", {
        processType: workflowProcess.processType,
        processName: workflowProcess.processName
      });

      const base64String = response?.base64 || response;
      if (!base64String || typeof base64String !== "string") {
        throw new Error("Invalid response: no Excel data");
      }

      const base64 = base64String.includes(",")
        ? base64String.split(",")[1]
        : base64String;

      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `UserApprovals_${workflowProcess.processName}_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error("Download failed:", error);
      toastNotify({
        title: "Download Failed",
        message: error.message || "Please try again",
        type: "error",
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <ShadowBox>
      <Flex
        justifyContent="end"
        alignItems="center"
        gap={{ base: 2, lg: 4 }}
        mb={5}
      >
        <SearchBox onSearch={() => { }} setValue={setSearch} value={search} />
        <Box display={{ base: "none", md: "block" }}>
          <Button
            border="2px solid"
            borderColor="teal.300"
            bg="white"
            fontSize="sm"
            color="teal.400"
            _hover={{ bg: "teal.300", color: "white" }}
            onClick={() => {
              setSearch("");
              setCurrentPage(1);
              handleGetWorkFlow();
            }}
          >
            <HiOutlineRefresh fontSize="1.2rem" />
          </Button>
        </Box>
        <Box display={{ base: "none", md: "block" }}>
          <AddFormForeign handleGetData={handleGetWorkFlow} />
        </Box>
        <Box display={{ base: "none", md: "block" }}>
          <Button
            color="white"
            _hover={{
              bg: "teal.400"
            }}
            bg="teal.300"
            fontSize={{ base: "xs", lg: "sm" }}
            onClick={() => setIsForeignDrawerOpen(true)}
          >
            Add Region
          </Button>
        </Box>
        <Box display={{ base: "none", md: "block" }}>
          <Tooltip label="Download User Approvals Excel" hasArrow>
            <Button
              border="2px solid"
              borderColor="green.700"
              bg="white"
              fontSize="sm"
              color="green.700"
              _hover={{ borderColor: "green.300" }}
              onClick={handleDownloadExcel}
              isLoading={isDownloading}
              isDisabled={isDownloading}
            >
              <DownloadIcon fontSize="1.2rem" />
              Download Excel
            </Button>
          </Tooltip>
        </Box>
        <Box display={{ base: "block", md: "none" }}>
          <Popover>
            <PopoverTrigger>
              <Button bg="teal.300" color="white" _hover={{ bg: "teal.400" }}>
                Action
              </Button>
            </PopoverTrigger>
            <PopoverContent maxW="180px">
              <PopoverArrow />
              <PopoverCloseButton />
              <PopoverBody>
                <Flex
                  alignItems="center"
                  gap={2}
                  flexDirection="column"
                >
                  <Box mt={4}>
                    <AddFormEmerging handleGetData={handleGetWorkFlow} />
                  </Box>
                  <Box mt={4}>
                    <Button
                      border="2px solid"
                      borderColor="teal.300"
                      bg="white"
                      fontSize="sm"
                      color="teal.400"
                      _hover={{ bg: "teal.300", color: "white" }}
                      onClick={() => {
                        setSearch("");
                        setCurrentPage(1);
                        handleGetWorkFlow();
                      }}
                      w="100%"
                    >
                      <HiOutlineRefresh fontSize="1.2rem" />
                    </Button>
                  </Box>
                </Flex>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Box>
      </Flex>
      <Box
        position="relative"
        overflow="auto hidden"
        className="customScrollBar"
      >
        <Table variant="striped">
          <Thead>
            <Tr>
              <Th>Identifier</Th>
              <Th>Logo</Th>
              <Th>WorkFlow Name</Th>
              <Th>Process Name</Th>
              <Th>Process Type</Th>
              <Th>Number of Levels</Th>
              <Th>Default Active</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <TableLoader loader={loading} show={data.length}>
            <Tbody>
              {data.map((workflow: any, index: number) => (
                <Tr key={index}>
                  <Td
                    alignItems="center"
                    display="flex"
                    cursor="pointer"
                    onClick={() => handleCopyClick(workflow?.identifier)}
                  >
                    <Tooltip label={workflow?.identifier} hasArrow>
                      {`${workflow?.identifier?.slice(0, 10)}...`}
                    </Tooltip>
                    <Text
                      mt={1}
                      marginLeft="5px"
                      color="blue"
                      fontSize="10px"
                      textColor={
                        isCopied === workflow?.identifier
                          ? "blue"
                          : "transparent"
                      }
                    >
                      copied
                    </Text>
                  </Td>
                  <Td>
                    <Tooltip label="View Logo">
                      <Text
                        isTruncated
                        w="4rem"
                        textDecoration={"underline"}
                        color="blue.400"
                        cursor="pointer"
                        onClick={() => handleOpenModal(workflow?.values?.logo)}
                      >
                        {workflow?.values?.logo?.name}
                      </Text>
                    </Tooltip>
                  </Td>
                  <Td whiteSpace="nowrap">{workflow?.workFlowName}</Td>
                  <Td whiteSpace="nowrap">{workflow?.processName}</Td>
                  <Td whiteSpace="nowrap">{workflow?.processType}</Td>
                  <Td>{workflow?.values?.levels}</Td>
                  <Td
                    cursor="pointer"
                    onClick={() => {
                      setOpenDefaultModal({
                        open: true,
                        data: { ...workflow },
                      });
                    }}
                  >
                    {workflow?._id?.toString() ===
                      accountDetails?.defaultWorkflow?.toString()
                      ? "Yes"
                      : "No"}
                  </Td>
                  <Td>
                    <Flex alignItems="center" justifyContent="end">
                      <Tooltip label="View Workflow" hasArrow arrowSize={15}>
                        <Flex
                          alignItems="center"
                          cursor="pointer"
                          color="green.500"
                          _hover={{ color: "green.600" }}
                          onClick={() => handleOpenPreviewModal(workflow)}
                        >
                          <Box mr=".5rem" fontSize="1.4rem">
                            <AiFillEye />
                          </Box>
                        </Flex>
                      </Tooltip>
                      <Tooltip label="Edit Workflow" hasArrow arrowSize={15}>
                        <Flex
                          alignItems="center"
                          cursor="pointer"
                          mx="1rem"
                          color="green.500"
                          onClick={() => {
                            setOpenEditModel({
                              open: true,
                              data: { ...workflow },
                            });
                          }}
                          _hover={{ color: "green.600" }}
                        >
                          <Box mr=".5rem">
                            <FaEdit />
                          </Box>
                        </Flex>
                      </Tooltip>
                      <Tooltip label="Clone Workflow" hasArrow arrowSize={15}>
                        <Flex
                          alignItems="center"
                          cursor="pointer"
                          mx="1rem"
                          color="teal.500"
                          onClick={() => handleClone(workflow)}
                          _hover={{ color: "teal.600" }}
                        >
                          <Box mr=".5rem">
                            {cloneLoading === workflow._id ? "..." : <FaClone />}
                          </Box>
                        </Flex>
                      </Tooltip>
                      <Tooltip label="Delete Workflow" hasArrow arrowSize={15}>
                        <Flex
                          alignItems="center"
                          cursor="pointer"
                          color="red.500"
                          onClick={() => {
                            setOpenDeleteModel({
                              open: true,
                              data: workflow,
                            });
                          }}
                          _hover={{ color: "red.600" }}
                        >
                          <Box mr=".5rem">
                            <RiDeleteBin5Line />
                          </Box>
                        </Flex>
                      </Tooltip>
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </TableLoader>
        </Table>
      </Box>
      <Pagination totalPages={totalPages} handlePageChange={handlePageChange} />
      <DeleteModal
        isOpen={openDeleteModel.open}
        onClose={() => {
          setOpenDeleteModel({ data: null, open: null });
        }}
        id={openDeleteModel?.data?._id}
        status={openDeleteModel?.data?.defaultActive}
        handleUpdate={handleGetWorkFlow}
        key={`delete-${openDeleteModel?.data?._id}`}
      />
      {openEditModel.open && (
        <EditFormForeign
          isOpen={openEditModel.open}
          initialValues={openEditModel.data}
          setIsOpen={(key: any) => setOpenEditModel({ open: key })}
          handleGetData={handleGetWorkFlow}
        />
      )}
      <SetDefaultModal
        isOpen={openDefaultModal.open}
        data={openDefaultModal.data}
        onClose={() => setOpenDefaultModal({ data: null, open: false })}
        id={openDefaultModal?.data?._id}
        key={`defaultModel-${openDeleteModel?.data?._id}`}
      />
      <LogoViewer
        isOpen={logo.open}
        onClose={() => handleCloseModal()}
        values={logo.data}
      />
      <PreviewModal
        isOpen={isPreviewOpen.open}
        onClose={() => handleClosePreviewModal()}
        values={isPreviewOpen.data}
        isSubmit={isSubmit}
        setIsSubmit={setIsSubmit}
      />
      <ForeignRegionDrawer
        isOpen={isForeignDrawerOpen}
        onClose={() => setIsForeignDrawerOpen(false)}
      />
    </ShadowBox>
  );
}

export default WorkFlowTableEmerging;
